import { render, staticRenderFns } from "./talk-form.vue?vue&type=template&id=7b5b25e6&"
import script from "./talk-form.vue?vue&type=script&lang=js&"
export * from "./talk-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports